var map = {
	"./en/authPages.json": 90211,
	"./en/chat.json": 58330,
	"./en/errors.json": 76496,
	"./en/general.json": 27355,
	"./en/homePage.json": 68064,
	"./en/hrmEmployees.json": 57255,
	"./en/sorting.json": 156,
	"./en/terms.json": 67066,
	"./en/workspace.json": 95186,
	"./ru/authPages.json": 85041,
	"./ru/chat.json": 31087,
	"./ru/errors.json": 15514,
	"./ru/general.json": 84678,
	"./ru/homePage.json": 87891,
	"./ru/hrmEmployees.json": 50108,
	"./ru/sorting.json": 15175,
	"./ru/terms.json": 24850,
	"./ru/workspace.json": 41392
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85189;